export default __webpack_public_path__ + "static/Plots0039-39a9ede5710a27a1645332f7b4e4be32.jpg";